import {Pipe, PipeTransform} from '@angular/core';
import {WeightMeasurementUnit} from 'src/app/infrastructure/moovement-api/models/asset';

const transformAbbreviated = (value: WeightMeasurementUnit) => {
  switch (value) {
      case WeightMeasurementUnit.KILOGRAM:
        return "kg";
      case WeightMeasurementUnit.POUND:
        return "lb"
    }
}

const transform = (value: WeightMeasurementUnit) => {
  switch (value) {
      case WeightMeasurementUnit.KILOGRAM:
        return "Kilogram (kg)";
      case WeightMeasurementUnit.POUND:
        return "Pound (lb)"
    }
}

@Pipe({
  name: 'weightMeasurementUnit',
  standalone: true
})
export class WeightMeasurementUnitPipe implements PipeTransform {
  public transform(value?: WeightMeasurementUnit, format?: string): string | undefined {
    if (!value) return undefined;

    if (format === 'abbreviated') return transformAbbreviated(value);

    return transform(value);
  }
}
